import {process, checkInput, changeSample, uncheckChemistryAccordion, countFor } from './helpers/sampleProcessor'
import {checkOtherOption } from './helpers/otherOptionsProcessor'
import {touchAll } from './helpers/checkFieldsForValidity'

export default (state = {}, action)=>{
    let new_state = state;

    switch (action.type) {
        case 'change':
            new_state = {
                ...state,
                hi: state.hi + 1
            }
            break;
        case 'change_samples':
            new_state = {
                ...state,
                samples: process(state, action.value)
            };
            break;
        case 'update_field':
            new_state = {
                ...state,
                fields: {
                    ...state.fields,
                    [action.name]: {
                        ...state.fields[action.name],
                        ...action.value,
                        is_touched: true
                    }
                }
            };
            break;
        case 'click_accordion':
            if(!action.checked) {
                new_state = {
                    ...state,
                    samples: uncheckChemistryAccordion(state, state.samples, action.index)
                }
            }
            break;
        case 'touch_all_fields':
            new_state = {
                ...state,
                fields: {
                    ...touchAll(state.fields)
                }
            };
            break;
        case 'check_input':
            new_state = {
                ...state,
                samples: checkInput(state, action)
            };
            break;
        case 'check_other_options':
            new_state = {
                ...state,
                other_options: checkOtherOption(state, action)
            };
            break;
        case 'change_sample':
            new_state = {
                ...state,
                samples: changeSample(state.samples, action.index, action.sample)
            }
            break;
        default:
            break;
    }

    const nstate = summarizeCost(new_state);
    return nstate;
}

const summarizeCost = (state)=>{
    let finalCost = 0;

    state.samples.forEach((sample)=>{
        finalCost += sample.totalCost
    })

    const water_chem = state.other_options['water_chemistry']
    finalCost += water_chem.checked ? water_chem.cost : 0;
    const water_chem_plus = state.other_options['water_chemistry_plus']
    finalCost += water_chem_plus.checked ? water_chem_plus.cost : 0;

    const checkCount = {
            'production_suite': countFor(state, 'production_suite'),
            'alcolyzer_selzer': countFor(state, 'alcolyzer_selzer'),
            'bacterial_analysis': countFor(state, 'bacterial_analysis'),
            'yeast_analysis': countFor(state, 'yeast_analysis'),
    }

    return {
        ...state,
        finalCost: finalCost,
        checkCount,
    }
};